import { render, staticRenderFns } from "./GeneralTopbar.vue?vue&type=template&id=6458b940&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconUser: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/icons/IconUser.vue').default,IconLogout: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/icons/IconLogout.vue').default})
